import CNavbar from '../Components/Contact/CNavbar/CNavbar'
import GetInTouch from '../Components/Contact/GetInTouch/GetInTouch'
import VisitOurClinic from '../Components/Contact/VisitOurClinic/VisitOurClinic'
import Footer from '../Components/Contact/Footer/Footer'

const Contact = () => {
  return (
    <div>
      <CNavbar />
      <GetInTouch />
      <VisitOurClinic />
      <Footer />
    </div>
  )
}

export default Contact